import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultModule } from './default-module.js';

const DefaultApartment = {
    type: RG_TYPE.Apartment,
    name: 'apartment',
    anchor: [0.5, 0, 0.5],
    data: {
        level: -1,
        levelId: '',
        occupants: 0,
        bedrooms: 0,
        habitableRooms: 0,
        muscleID: '',
        nia: 0,
        category: ''
    },
    children: [
        { ...DefaultModule }
    ]
};

export { DefaultApartment };
//# sourceMappingURL=default-apartment.js.map
